import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FloatingSupportPopover } from "stm-frontend-library";

const GAP_ABOVE_FOOTER = 16;
const DEFAULT_BOTTOM = 24;
const FOOTER_SELECTOR = ".footer";

const Wrapper = styled.div`
  position: fixed;
  bottom: ${({ $bottom }) => $bottom}px;
  right: 60px;
  z-index: 1050;
  transition: bottom 0.1s ease-out;
`;

const SupportButton = () => {
  const [bottom, setBottom] = useState(DEFAULT_BOTTOM);

  useEffect(() => {
    const footer = document.querySelector(FOOTER_SELECTOR);
    if (!footer) {
      setBottom(DEFAULT_BOTTOM);
      return;
    }

    const updatePosition = () => {
      const rect = footer.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      if (rect.top < viewportHeight) {
        setBottom(viewportHeight - rect.top + GAP_ABOVE_FOOTER);
      } else {
        setBottom(DEFAULT_BOTTOM);
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          updatePosition();
          window.addEventListener("scroll", updatePosition, { passive: true });
          window.addEventListener("resize", updatePosition);
        } else {
          setBottom(DEFAULT_BOTTOM);
          window.removeEventListener("scroll", updatePosition);
          window.removeEventListener("resize", updatePosition);
        }
      },
      { threshold: 0, rootMargin: "0px" }
    );

    observer.observe(footer);
    updatePosition();

    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", updatePosition);
      window.removeEventListener("resize", updatePosition);
    };
  }, []);

  return (
    <Wrapper $bottom={bottom}>
      <FloatingSupportPopover />
    </Wrapper>
  );
};

export default SupportButton;
